import ClientsAxios from "../../client-axios";
import { DeclarationCreateRequest, DeclarationListRequest } from "../../dto/request/master/declarationMaster.type";
import { ResponseEntity } from "../../dto/response";

const { API_SERVER } = ClientsAxios;

export const FetchDeclarationsListService = async (payload: DeclarationListRequest | {}) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('declaration-master/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const CreateDeclarationService = async (payload: DeclarationCreateRequest, isUpdate: boolean = false) => {
    const responseEntity = new ResponseEntity<{message: string}>();
    try {
        const urlType = isUpdate ? 'update' : 'store';
        const response = await API_SERVER.post(`declaration-master/${urlType}`, payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const DeleteDeclarationService = async (payload: { id: number }) => {
    const responseEntity = new ResponseEntity<any>();
    try {
        const response = await API_SERVER.post('declaration-master/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}